const matchesFocusVisible = (element) => {
  try {
    return element.matches(':focus-visible');
  } catch (error) {
    // Older test DOMs do not support this selector.
    return true;
  }
};

export default matchesFocusVisible;
